var exports = {
  "nM": "ComparisonCheckRow.module__row___bkN6YT",
  "N4": "ComparisonCheckRow.module__feature___bkN6YT",
  "oo": "ComparisonCheckRow.module__featureText___bkN6YT",
  "a7": "ComparisonCheckRow.module__valuesContainer___bkN6YT",
  "S7": "ComparisonCheckRow.module__valueCell___bkN6YT",
  "oE": "ComparisonCheckRow.module__checkIcon___bkN6YT",
  "T7": "ComparisonCheckRow.module__dash___bkN6YT",
};

module.exports = exports;
